export const fieldTranslations: Record<string, string> = {
  strategy_from_id: "Stratégie (depuis)",
  strategy_to_id: "Stratégie (vers)",
  quantity: "Quantité",
  date: "Date",
  weight: "Poids",
  market_value_local_ccy: "Valeur marché (devise locale)",
  market_value_ptf_ccy: "Valeur marché (devise ptf)",
  exposition_local_ccy: "Exposition (devise locale)",
  exposition_ptf_ccy: "Exposition (devise ptf)",
  time_serie_file_id: "Fichier de série temporelle",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
